import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FontColorIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M1.66663 16.6667H18.3333V20H1.66663V16.6667ZM4.57496 14.1667H6.59163L7.64996 11.1833H12.3583L13.4083 14.1667H15.425L11.0416 2.5H8.95829L4.57496 14.1667ZM8.25829 9.49167L9.94996 4.66667H10.05L11.7416 9.49167H8.25829Z" />
  </Icon>
);

export default memo(FontColorIcon);
